import { render } from "./NotificationDocument.vue?vue&type=template&id=8437085e&scoped=true&ts=true&lang=pug"
import script from "./NotificationDocument.vue?vue&type=script&lang=ts"
export * from "./NotificationDocument.vue?vue&type=script&lang=ts"

import "./NotificationDocument.vue?vue&type=style&index=0&id=8437085e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8437085e"]])

export default __exports__